import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Box, Flex, Text, Image, Button } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { Path } from 'config/constants/paths'

export const storageKey = 'farm-apr'

export const FarmAprBanner = ({ onCloseClick }) => {
  const { t } = useTranslation()
  const routerHistory = useHistory()

  return (
    <FarmAprBannerCard>
      <BgImage />

      <ContentWrapper>
        <MobileTextsWrapper>
          <Text as="h3" color="white" fontSize="18px" fontWeight="700" mb="8px">
            {t('Stake your tokens into our farms to enjoy >100% APR!')}
          </Text>
          <Text as="p" color="white" fontSize="14px">
            {t('APR varies based on total staked amount')}
          </Text>
        </MobileTextsWrapper>
        <DesktopTextsWrapper>
          <BannerTitle as="h3" color="white" fontWeight="700">
            {t('Stake your tokens into our farms to enjoy >100% APR!')}
          </BannerTitle>
          <Text as="p" color="white" fontSize="14px">
            <BannerDesc>{t('Go to Farm Page > sort by APR > Stake your tokens into our high APR farms!')}</BannerDesc>
            <BannerDesc>{t('(APR varies based on total staked amount)')}</BannerDesc>
          </Text>
        </DesktopTextsWrapper>
        <BtnsWrapper>
          <Button variant="tertiary" onClick={() => routerHistory.push(Path.VVS_FARM_SIMPLE)}>
            {t('Go to Farm!')}
          </Button>
        </BtnsWrapper>
      </ContentWrapper>

      <CloseImageButton
        height={22}
        width={22}
        src="/images/vvsMinerMole/close_button.png"
        alt="close"
        onClick={onCloseClick}
      />
    </FarmAprBannerCard>
  )
}

const FarmAprBannerCard = styled(Flex)`
  border-radius: ${({ theme }) => theme.radii.card};
  overflow: hidden;
  width: 100%;
  padding: 0px;
  max-width: 1200px;
  align-self: stretch;

  background: linear-gradient(90deg, #5bc098 0%, #5756cc 100%);
  position: relative;
  margin-top: 10px;
  margin-bottom: 28px;
  margin-left: 30px;
  margin-right: 30px;

  align-items: start;

  ${({ theme }) => theme.mediaQueries.sm} {
    align-items: center;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    max-height: 120px;
  }
`

const BgImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('/images/farmAprBanner/gem_mobile.png');
  background-repeat: no-repeat;
  pointer-events: none;

  background-position: right bottom;
  background-size: auto 90%;
  ${({ theme }) => theme.mediaQueries.sm} {
    background-image: url('/images/farmAprBanner/gem_desktop.png');
    background-position: 97% bottom;
    background-size: auto 100%;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    background-position: 97% bottom;
    background-size: auto 100%;
  }
  ${({ theme }) => theme.mediaQueries.xxl} {
    background-position: 97% center;
    background-size: auto 100%;
  }
`
const ContentWrapper = styled(Flex)`
  flex: 1;
  align-self: stretch;
  padding: 16px;
  flex-direction: column;
  align-items: start;
  justify-content: space-around;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    align-items: center;
    padding: 0 112px 0 16px;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    padding: 0 150px 0 30px;
  }
`

const MobileTextsWrapper = styled(Box)`
  ${({ theme }) => theme.mediaQueries.sm} {
    display: none;
  }
`
const BtnsWrapper = styled(Flex)`
  gap: 15px;

  & > button {
    padding: 0 16px;
    background: white;
    color: #46a1c2;
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    padding-right: 16px;
    & > button {
      height: 44px;
      padding: 0 12px;
    }
  }
  ${({ theme }) => theme.mediaQueries.md} {
    padding-right: 30px;
    & > button {
      height: 48px;
      padding: 0 24px;
    }
  }
`
const DesktopTextsWrapper = styled(Box)`
  flex: 1;
  display: none;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
    order: 1;
    padding-bottom: 10px;
  }
`
const CloseImageButton = styled(Image)`
  margin-top: 12px;
  margin-right: 12px;
  cursor: pointer;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-top: 16px;
    margin-right: 16px;
    align-self: start;
  }
`

const BannerTitle = styled(Text)`
  font-weight: 700;
  font-size: 18px;
  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 24px;
  }
`

const BannerDesc = styled.span`
  display: inline-block;
`
